export class FragmentAnalysis {
  carrierBarcode: string;
  rackPosition: string;
  sampleBarcode: string;
  positionRow: number;
  concentrationValue: string;
  assayType: string;
  assayTypeCategory: string;
  plateBarcode: string;
  machineType: string;
  labId: string;
  active:boolean;
}
